import { useLang } from "../i18n/LangContext";
import { useReveal } from "../hooks/useReveal";
import { TrendingUp } from "lucide-react";

function Case({ item, index }) {
    const { ref, className } = useReveal(0.1);
    return (
        <article
            ref={ref}
            data-testid={`case-${index}`}
            style={{ transitionDelay: `${index * 80}ms` }}
            className={`${className} group p-8 lg:p-10 bg-white border border-border hover:border-ink transition-colors`}
        >
            <div className="flex items-center justify-between mb-6">
                <span className="font-display text-xs uppercase tracking-widest text-ink-muted">
                    Case 0{index + 1}
                </span>
                <span className="w-10 h-10 bg-mint flex items-center justify-center">
                    <TrendingUp size={18} className="text-ink" />
                </span>
            </div>
            <h3 className="font-display font-bold uppercase text-xl md:text-2xl tracking-tight text-ink leading-tight">
                {item.sector}
            </h3>
            <div className="mt-5 pt-5 border-t border-border">
                <div className="font-display text-xs uppercase tracking-widest text-ink-muted mb-1">
                    Challenge
                </div>
                <p className="text-sm text-ink-soft leading-relaxed">
                    {item.challenge}
                </p>
            </div>
            <div className="mt-4 pt-4 border-t border-border">
                <div className="font-display text-xs uppercase tracking-widest text-ink mb-1">
                    Outcome
                </div>
                <p className="text-sm text-ink leading-relaxed font-medium">
                    {item.outcome}
                </p>
            </div>
        </article>
    );
}

export default function CaseStudies() {
    const { t } = useLang();
    const { ref, className } = useReveal();
    return (
        <section
            id="cases"
            data-testid="cases-section"
            className="py-24 md:py-32 bg-paper-alt"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-10">
                <div ref={ref} className={`${className} max-w-3xl mb-16`}>
                    <div className="flex items-center gap-3 mb-6">
                        <span className="w-10 h-px bg-ink" />
                        <span className="font-display text-xs uppercase tracking-[0.3em] text-ink-muted">
                            {t.cases.kicker}
                        </span>
                    </div>
                    <h2 className="font-display font-bold uppercase text-4xl md:text-5xl lg:text-6xl leading-[0.95] tracking-tight text-ink">
                        {t.cases.title}
                    </h2>
                    <p className="mt-6 text-base md:text-lg text-ink-soft">
                        {t.cases.subtitle}
                    </p>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
                    {t.cases.items.map((c, i) => (
                        <Case key={i} item={c} index={i} />
                    ))}
                </div>
            </div>
        </section>
    );
}
